import { render } from 'preact';
import { html } from 'htm/preact';
import DocumentListingWidget from './document-listing-widget';

function parseDataset({ input = '', fallback }) {
  try {
    return JSON.parse(input);
  } catch (err) {
    // Do nothing.
  }

  return fallback;
}

async function mount({ rootElement = null }) {
  // const preact = await import('preact');
  // const htm = await import('htm/preact');

  const { categories, translations, language } = rootElement.dataset;
  const container = rootElement.querySelector('.document-listing');

  const options = {
    categories: parseDataset({ input: categories, fallback: [] }),
    translations: parseDataset({ input: translations, fallback: [] }),
    language,
  };

  render(html`
    <${DocumentListingWidget}
      categories=${options.categories}
      translations=${options.translations}
      language=${options.language}
    />`, container);
}

function init() {
  const blocks = document.querySelectorAll('.section--document-listing');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
